import React, {useEffect, useMemo, useState} from 'react';
import styles from "./charts.module.scss";
import {Candle, TimeFrames} from "../../../../../../shared/types";
import Chart from "./chart/Chart";
import {useAppSelector} from "../../../../../../store/store";

interface Props {
  active: boolean
  specificityOfRecomendsByStrategy: string
  quotes: Record<TimeFrames, Candle[]>
}

const Charts = ({active, specificityOfRecomendsByStrategy, quotes}: Props) => {

  const screenWidth = useAppSelector(state => state.appReduser.screenWidth)

  const specificityOfRecomendsByStrategyHighTf: TimeFrames = useMemo(() => JSON.parse(specificityOfRecomendsByStrategy).highTf, [specificityOfRecomendsByStrategy])
  const specificityOfRecomendsByStrategyHighZz: number = useMemo(() => JSON.parse(specificityOfRecomendsByStrategy).highZz, [specificityOfRecomendsByStrategy])
  const specificityOfRecomendsByStrategyLowTf: TimeFrames = useMemo(() => JSON.parse(specificityOfRecomendsByStrategy).lowTf, [specificityOfRecomendsByStrategy])
  const specificityOfRecomendsByStrategyLowZz: number = useMemo(() => JSON.parse(specificityOfRecomendsByStrategy).lowZz, [specificityOfRecomendsByStrategy])

  const [widthWrap, setWidthWrap] = useState<number>()
  const [highTfIsActive, setHighTfIsActive] = useState(true)

  //расчет размера canvas
  useEffect(() => {
    if (screenWidth) {
      const width = (screenWidth - 64) * 2 // 64 - это с боков от попапа, 2 - количество графиков
      setWidthWrap(width)
    }
  }, [screenWidth])

  const toggleScreen = () => {
    const prevState = highTfIsActive
    setHighTfIsActive(!prevState)
  }

  return (
    <div className={[styles.container, active ? styles.active : ''].join(' ')}>
      <div className={styles.content}>
        <div className={styles.buttons}>
          <span
            onClick={toggleScreen}
            style={{
              backgroundColor: highTfIsActive ? '#f0fff0' : '#fff0f0',
            }}
            onMouseOver={(event) => event.currentTarget.style.background = highTfIsActive ? '#fff0f0' : '#f0fff0'}
            onMouseOut={(event) => event.currentTarget.style.background = highTfIsActive ? '#f0fff0' : '#fff0f0'}
          >
            {
              highTfIsActive ? 'high TF' : 'low TF'
            }
          </span>
        </div>
        <div className={[styles.wrap, highTfIsActive ? styles.highTfIsActive : ''].join(' ')}
             style={{width: `${widthWrap}px`}}
        >
          <Chart active={active} quotes={quotes} tfByRecomendsStrategy={specificityOfRecomendsByStrategyHighTf}
                 zzByRecomendsStrategy={specificityOfRecomendsByStrategyHighZz}/>
          <Chart active={active} quotes={quotes} tfByRecomendsStrategy={specificityOfRecomendsByStrategyLowTf}
                 zzByRecomendsStrategy={specificityOfRecomendsByStrategyLowZz}/>
        </div>
      </div>
    </div>
  );
};

export default Charts;